import { values } from './enums'

const _enum = {
  Name: 0,
  LatinName: 1
}

export const propertyToVerify = {
  enumName: 'PropertyToVerify',
  enum: _enum,
  values: values(_enum)
}



// WEBPACK FOOTER //
// ./src/enums/PropertyToVerify.js